import React from 'react';
import {connect} from "react-redux";
import getCustomerList from "../../actions/getCustomerList";
import {Form} from 'antd';
import MainLayout from "../Layout/Layout";
import showLogin from "../../actions/showLogin";
import getReportPreview from "../../actions/getReportPreview";
import ReportResultTable from "../ReportResultTable/ReportResultTable";
import {CustomerFilterItem, DateRangeFilterItem, ReportFilterActions, ReportFilterHeader} from "../ReportFilters/ReportFilters";
import {decodeBase64ToText, handleBase64Response, parseCsvText, splitReportSummaryRows} from "../../utils";

class SignerOperations extends React.Component
{
    state={report:null,base64Report:null,summaryItems:[]};

    componentDidMount()
    {
        if(!this.props.login.tokenId || !this.props.login.profileObj)
            this.props.showLogin();
        this.props.getCustomerList();
    }

    handleSearch=(formValues)=>
    {
        this.props.getReportPreview("getOperationsReport",formValues,(base64Report)=>{
            const parsedReport=parseCsvText(decodeBase64ToText(base64Report));
            const {report,summaryItems}=splitReportSummaryRows(parsedReport,[
                'TOTAL OPERACIONES',
                'TOTAL DOCUMENTOS'
            ]);

            this.setState({
                base64Report,
                report,
                summaryItems
            });
        });
    };

    handleDownload=()=>
    {
        handleBase64Response(this.state.base64Report,"reporte.csv");
    };

    render()
    {
        return <MainLayout title={'logo'} size={'medium'} variant="report"
                           reportTitle="Consumo de Operaciones"
                           reportDescription="Consulta el consumo de operaciones por cliente y periodo antes de descargar el CSV.">
            <Form className="report-filter-panel" layout="vertical" name="operations"
                  onFinish={this.handleSearch}>
                <ReportFilterHeader/>
                <div className="report-filter-fields">
                    <CustomerFilterItem customerList={this.props.customerList}/>
                    <DateRangeFilterItem/>
                </div>
                <ReportFilterActions>Generar reporte</ReportFilterActions>
            </Form>
            <ReportResultTable title="Consumo de Operaciones" parsedReport={this.state.report}
                               summaryItems={this.state.summaryItems} onDownload={this.handleDownload}/>
        </MainLayout>;
    }
}

function mapStateToProps(state) {
    return {
        login: state.login,
        customerList:state.customer.customerList
    }
}
export default connect(mapStateToProps, {getCustomerList,showLogin,getReportPreview})(SignerOperations);
